import API from "../../lib/api";
import { API_PRODUCT_DETAILS, GENERATE_API_MILESTONE_URL } from "../../constants/config";

export default class Product {
  static getProductsList() {
    return API.get({
      url: `${API_PRODUCT_DETAILS}`
    }).then(data => ([data.data]));
  }

  static getProductDetails() {
    return API.get({
      url: `${API_PRODUCT_DETAILS}`
    }).then(data => (data.data));
  }

  static createMilestone({ epicId, data }) {
    const url = GENERATE_API_MILESTONE_URL({ epicId });
    return API.post({
      url,
      params: data
    });
  }

  static updateMilestone({ epicId, data }) {
    const url = GENERATE_API_MILESTONE_URL({ epicId });
    return API.put({
      url: `${url}/${data.id}`,
      params: data
    });
  }
}